<div style="position:relative;">
  <iframe
    title="map"
    width="100%"
    height="300"
    frameborder="0"
    style="border:0"
    src="{url}}"
    allowfullscreen
  />
  {#if drawCircle}
    <div style="position:absolute;top:50%;left:50%;">
      <div
        style="position:absolute;top:-25px;left:-25px;width:50px;height:50px;background-color:rgba(255,35,76, 0.3);border-radius:25px;"
      >
        &nbsp;
      </div>
    </div>
  {/if}
</div>

<script lang="ts">
  export let postcode :string | undefined = undefined,
    location:GeoPoint | undefined = undefined,
    drawCircle = false;

  let url : string;

  if (postcode) {
    url = `https://www.google.com/maps/embed/v1/place?q=${encodeURIComponent(postcode + ', United Kingdom')}&key=AIzaSyDKLXUuHHIOjRv7yHiVIQEOiEMzjzKPw-o&zoom=11`;
  } else {
    url = `https://www.google.com/maps/embed/v1/view?center=${location!.latitude},${location!.longitude}&key=AIzaSyDKLXUuHHIOjRv7yHiVIQEOiEMzjzKPw-o&zoom=11`;
  }
</script>
